<template>
  <div>
    <div
      class="d-flex justify-content-start align-items-center pointer"
      @click="visible = !visible"
    >
      <slot name="title"></slot>
      <i
        class="fal fa-chevron-down rotate ms-3 pt-1"
        :class="{ down: visible }"
      ></i>
    </div>

    <Collapse role="tabpanel" :when="visible">
      <slot name="content"></slot>
    </Collapse>
  </div>
</template>

<script>
import { Collapse } from 'vue-collapsed'

export default {
  name: 'HMCollapse',
  props: {
    openVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Collapse,
  },
  data() {
    return {
      visible: this.openVisible,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.pointer {
  cursor: pointer;
}

.rotate {
  transition: all 0.2s ease-in-out;
  &.down {
    transform: rotate(180deg);
  }
}
</style>
